import React from 'react'
import { Link } from 'react-router-dom'
import { AsciiDivider } from '../terminal/AsciiDivider'
import { TerminalPrompt } from '../terminal/TerminalPrompt'
import { SubscribeForm } from '../newsletter/SubscribeForm'

export const Footer: React.FC = () => {
  return (
    <>
      <style>{`
        .footer {
          margin-top: auto;
          padding: 0 20px 28px;
          font-family: 'JetBrains Mono', 'Courier New', monospace;
        }
        .footer-inner {
          max-width: 1100px;
          margin: 0 auto;
        }
        .footer-links {
          display: flex;
          gap: 16px;
          margin-bottom: 8px;
          flex-wrap: wrap;
          align-items: center;
        }
        .footer-link {
          font-size: 0.78rem;
          color: var(--text-secondary);
          text-decoration: none;
          transition: color 0.15s ease;
        }
        .footer-link:hover {
          color: var(--accent-blue);
          text-decoration: none;
        }
        .footer-divider {
          color: var(--border-color);
          font-size: 0.78rem;
        }
        .footer-copyright {
          font-size: 0.75rem;
          color: var(--text-muted);
          margin-bottom: 20px;
        }
        .footer-prompt {
          font-size: 0.82rem;
          margin-top: 16px;
        }
      `}</style>
      <footer className="footer">
        <div className="footer-inner">
          <AsciiDivider width={60} />

          <div className="footer-copyright">
            // CodeToByte &copy; {new Date().getFullYear()}
          </div>

          <div className="footer-links">
            <a
              href="https://github.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              aria-label="GitHub"
            >
              [github]
            </a>
            <a
              href="/rss.xml"
              className="footer-link"
              aria-label="RSS Feed"
            >
              [rss]
            </a>
            <span className="footer-divider">·</span>
            <Link to="/privacy" className="footer-link">
              [privacy policy]
            </Link>
            <Link to="/terms" className="footer-link">
              [terms]
            </Link>
            <Link to="/about" className="footer-link">
              [about]
            </Link>
          </div>

          <SubscribeForm variant="footer" />

          <div className="footer-prompt">
            <TerminalPrompt path="~" showCursor={true} />
          </div>
        </div>
      </footer>
    </>
  )
}
